@if (isOpen) {
  <div 
    class="modal-overlay" 
    (click)="onOverlayClick($event)"
    (keydown)="onKeydown($event)"
    (keyup.escape)="close()"
    tabindex="0"
    [attr.role]="ariaAttributes['role']"
    [attr.aria-modal]="ariaAttributes['aria-modal']"
    [attr.aria-labelledby]="ariaAttributes['aria-labelledby']"
    [attr.aria-label]="ariaAttributes['aria-label']">
    <div 
      #modalContent
      class="modal-content modal-content--{{ size }}" 
      (click)="$event.stopPropagation()"
      (keydown)="onKeydown($event)"
      (keyup.escape)="close()"
      tabindex="0">
      <div class="modal-header" [class.modal-header--no-title]="!hasTitle">
        @if (hasTitle) {
          @if (isStringTitle) {
            <h2 [id]="titleId" class="modal-title">{{ stringTitle }}</h2>
          } @else {
            @if (templateTitle) {
              <div [id]="titleId" class="modal-title">
                <ng-container *ngTemplateOutlet="templateTitle"></ng-container>
              </div>
            }
          }
        }
        @if (!hideCloseButton) {
          <button 
            #closeButton
            class="modal-close"
            [disabled]="disableCloseButton"
            (click)="close()"
            (keydown.enter)="close()"
            (keydown.space)="close()"
            (keyup.enter)="close()"
            (keyup.space)="close()"
            aria-label="Close modal"
            type="button">
            <svg class="modal-close-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        }
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}